import { validations } from "./validations";

const requiredDropdownFields = [
    "gender",
    "language_id",
    "ethnicity",
    "tattoos",
    "hair_color",
    "durationCycle",
    "currency",
    "status",
    "piercings",
    "eye_color",
];
const requiredTextInputFields = [
    "title",
    "numberOfSeats",
    "hair_length",
    "minAmount",
    "current_password",
    "new_password",
    "password_confirmation",
]; // Example, update as needed

export const getErrors = (
    inputs: Record<string, any>,
    errorObj: Record<string, string>
) => {
    const errors = { ...errorObj };

    let hasError = false;

    Object.keys(inputs).forEach((key) => {
        const isRequired =
            requiredDropdownFields.includes(key) ||
            requiredTextInputFields.includes(key);
        const error = validations(key, inputs[key], isRequired);
        if (error !== "") {
            hasError = true;
        }
        errors[key] = error;
    });

    return {
        hasError,
        errors,
    };
};
